<template>
    <div class="page-content">
        <h4 class="mt-n2 mb-4">
            Invoice Logs
        </h4>
        <div class="mt-4 card px-4 py-4">
            <h3>Overview</h3>
            <h5 class="mt-2" style="color: #333333">{{ formatDate(fromDate) }} - {{ formatDate(toDate) }}</h5>
            <div class="mt-4">
                <div class="mx-1 mb-3" :class="this.thisMonthStatus ? 'primary-button' : 'secondary-button'"
                    @click="SetTime(1)">
                    This Month
                </div>
                <div class="mx-1 mb-3" :class="this.lastMonthStatus ? 'primary-button' : 'secondary-button'"
                    @click="SetTime(2)">
                    Last Month
                </div>
                <div class="mx-1 mb-3" :class="this.customStatus ? 'primary-button' : 'secondary-button'"
                    @click="CustomTimeFilter()">
                    Custom Range
                </div>
            </div>
        </div>
        <div class="mt-4 p-4" style="background-color:#F9FAFB; border-radius: 24px;" v-if="this.customStatus">
            <h5 style="font-weight: 600;">Custom Date Range</h5>
            <div class="row mt-4">
                <div class="col-md-3 form-group mb-3">
                    <label class="input-hero" for="fromDate">
                        <input type="date" v-model="inputFromDate" class="input_area" id="fromDate" :max="maxDateTime">
                        <span class="input-name">From Date<span class="text-danger">*</span></span>
                    </label>
                </div>
                <div class="col-md-3 form-group mb-3">
                    <label class="input-hero" for="toDate">
                        <input type="date" v-model="inputToDate" class="input_area" id="toDate" :max="maxDateTime">
                        <span class="input-name">To Date<span class="text-danger">*</span></span>
                    </label>
                </div>
                <div class="col-md-3">
                    <button class="btn btn-primary me-3 mb-3" type="button" @click="selectedCustomTime()">
                        Check
                    </button>
                </div>

            </div>
        </div>
        <!-- ROLLBACK -->
        <div class="table-responsive card p-2" style="width: 100%; max-height: 500px;" v-if="hasInvoices">
            <table class="table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Client Code</th>
                        <th>Client ID</th>
                        <th>From date</th>
                        <th>To date</th>
                        <th>Created Date</th>
                        <th>Invoice No</th>
                        <th>Invoice Reg. ID</th>
                        <th>Invoice Type</th>
                        <th>Invoice User ID</th>
                        <th>Region Id</th>
                        <th>Remark</th>
                        <th>Test ID</th>
                        <th>Status</th>
                        <th>Zoho Invoice ID</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in paginatedInvoices" :key="invoice.id">
                        <td>{{ invoice.id }}</td>
                        <td>{{ invoice.clientCode }}</td>
                        <td>{{ invoice.clientId }}</td>
                        <td>{{ formatDate(invoice.fromDate) }}</td>
                        <td>{{ formatDate(invoice.toDate) }}</td>
                        <td>{{ formatDate(invoice.createdDate) }}</td>
                        <td>{{ invoice.invoiceNumber }}</td>
                        <td>{{ invoice.invoiceRegisterId }}</td>
                        <td>{{ invoice.invoiceType }}</td>
                        <td>{{ invoice.invoiceUserId }}</td>
                        <td>{{ invoice.regionId }}</td>
                        <td>{{ invoice.remark }}</td>
                        <td>{{ invoice.testId }}</td>
                        <td>{{ invoice.status }}</td>
                        <td>{{ invoice.zohoInvoiceId }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else>
            <img src="../../../public/dashboard-assets/images/M2/empty_record.png" style="width: 20%" class="my-5" />
            <h3 class="ms-5 mt-2">No Details Found</h3>
        </div>
        <!-- pagination -->
        <div class=" my-2">
            <paginate v-model="currentPage" :page-count="Page_count" :margin-pages="1" :page-range="1"
                :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'"
                :container-class="'pagination'" :page-class="'page-item'">
            </paginate>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import Paginate from "vuejs-paginate-next";

export default {
    name: "InvoiceLogs",
    components: {
        paginate: Paginate,
    },
    data() {
        return {
            invoiceNumber: "",
            fromDate: "",
            toDate: "",
            //for tabs:
            thisMonthStatus: true,
            lastMonthStatus: false,
            customStatus: false,

            maxDateTime: new Date().toISOString().slice(0, 10),
            inputFromDate: "",
            inputToDate: "",

            //for table
            invoices: [],

            //local pagination implemented.
            currentPage: 1,
            limit: 6, 
            Page_count: 0, 

        }
    },
    methods: {
        ...mapActions(["ShowWarningMessage", "GetBulkInvoicesByDate"]),
        formatDate(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY");
        },
        formatDate2(date) {
            return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY HH:mm:ss");
        },
        async fetchBulkInvoices() {
            const response = await this.GetBulkInvoicesByDate({
                fromDate: this.fromDate,
                toDate: this.toDate
            });
            if(response.object != null){
                this.invoices = response.object.data;
            // Calculate total pages
            this.Page_count = Math.ceil(this.invoices.length / this.limit);
            }else{
                this.invoices = []
            }
        },
        async SetTime(value) {
            this.ResetStatus();
            switch (value) {
                case 1:
                    this.fromDate = moment().startOf('month').format("YYYY-MM-DD 00:00:00"),
                    this.toDate = moment().format("YYYY-MM-DD HH:mm:ss"),
                    this.thisMonthStatus = true;
                    this.fetchBulkInvoices();
                    break;
                case 2:
                    this.fromDate = moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD 00:00:00");
                    this.toDate = moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD 23:59:59");
                    this.lastMonthStatus = true;
                    this.fetchBulkInvoices();
                    break;
                default:
                    this.fromDate = moment().startOf('month').format("YYYY-MM-DD 00:00:00"),
                    this.toDate = moment().format("YYYY-MM-DD HH:mm:ss"),
                    this.flag = true;
                    this.thisMonthStatus = true;
                    break;
            }

        },
        ResetStatus() {
            this.thisMonthStatus = false;
            this.lastMonthStatus = false;
            this.customStatus = false;
        },
        async CustomTimeFilter() {
            this.ResetStatus();
            this.customStatus = true;
        },
        async selectedCustomTime() {
            const date = new Date();
            if (this.inputFromDate === '' || this.inputToDate === '') {
                return this.ShowWarningMessage("Dates cant be empty")
            }
            if (this.inputFromDate >= this.inputToDate) {
                return this.ShowWarningMessage("From Date can't be greater than To Date");
            }
            else if (this.inputFromDate > date || this.inputToDate > date) {
                return this.ShowWarningMessage("Date can't be greater than Current Date");
            } else if (this.inputFromDate < '2000-01-01') {
                return this.ShowWarningMessage("From Date should be after the year 2000");
            } else if (this.inputToDate > '2050-01-01') return this.ShowWarningMessage("To Date should be before the year 2050");

            this.fromDate = moment(this.inputFromDate, "YYYY-MM-DD").format("YYYY-MM-DD 00:00:00");
            this.toDate = moment(this.inputToDate, "YYYY-MM-DD").format("YYYY-MM-DD 23:59:59");
            this.invoices = null;
            this.fetchBulkInvoices();
        },
        clickCallback(pageNum) {
            this.currentPage = pageNum;
        }
    },
    mounted() {
        // this.PartnerList();
        this.fromDate = moment().startOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.toDate = moment().format("YYYY-MM-DD HH:mm:ss");
        this.fetchBulkInvoices();
    },
    computed: {
        hasInvoices() {
            return this.invoices && this.invoices.length > 0;
        },
        paginatedInvoices() {
            const start = (this.currentPage - 1) * this.limit;
            const end = start + this.limit;
            return this.invoices.slice(start, end);
        }

    }
}
</script>

<style scoped>
.primary-button {
    background-color: #7b68ee;
    font-size: medium !important;
    /* font-weight: 600; */
    border-radius: 4px;
    color: #FFFFFF;
    border: 2px solid #7b68ee !important;
    /* width: 100%; */
    /* padding-top: 5px;
  padding-bottom: 5px; */
    display: inline-block;
    /* font-weight: 400; */
    /* color: #495057; */
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}

.secondary-button {
    /* background-color: #FFFFFF; */
    font-size: medium !important;
    font-weight: 600;
    border-radius: 4px;
    color: #7b68ee;
    border: 2px solid #7b68ee !important;
    /* width: 100%; */
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}

.form-control {
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
    transition: box-shadow 0.2s ease-in-out;
}

.form-control:focus {
    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);
    border-color: #4b2eee;
}
</style>